import React, {useState} from 'react';
import {MenuItem, Select} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import PropTypes from "prop-types";

export default function ColumnFilterSelect(props) {
    const {
        filterOptions,
        onChange,
        ...rest
    } = props;
    const [value, setValue] = useState('');

    const handleChange = event => {
        setValue(event.target.value);

        onChange && onChange(event.target.value);
    };

    return (
        <FormControl fullWidth>
            <Select
                value={value}
                displayEmpty
                onChange={handleChange}
                {...rest}>
                <MenuItem value="">Selecione...</MenuItem>
                {filterOptions.map(option => (
                    <MenuItem key={option.value + option.label} value={option.value}>{option.label}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

ColumnFilterSelect.propTypes = {
    id: PropTypes.string,
    filterOptions: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
};